import React from "react";
import { Link } from "react-router-dom";
import { useContact } from '../utils/ContactContext';


export default function Footer(props) {
   const { setOpen } = useContact();
  return (
    <div>
      {" "}
      <div class="home2-footer-top-section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8">
              <div class="footer-top-wrapper">
                <div class="footer-top-content text-center">
                  <h2>Ready to Build Something Together?</h2>
                  <p>
                    Book a free <span>30-minute session</span> with our
                    marketing specialist to talk about your unique topics,
                    challenges, and future projects.
                  </p>
                </div>
                <div class="footer-top-btn-area">
                  <a class="primary-btn1"href="#" onClick={(e) => { e.preventDefault(); setOpen(true); }}>
                    <span>
                      Get a Free Consultation
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                        </g>
                      </svg>
                    </span>
                    <span>
                      Get a Free Consultation
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                        </g>
                      </svg>
                    </span>
                  </a>
                </div>
                <ul class="img-list">
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-2.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-3.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-4.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-5.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-6.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="assets/image/start-up2/footer-top-img-7.png"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer-section home2-footer-section">
        <div class="container">
          <div class="footer-menu-wrap">
            <div class="row gy-5">
              <div class="col-lg-7">
                <div class="footer-contact-wrap">
                  <div class="title-area">
                    <h2>Driving Growth Through Smart Technology.</h2>
                  </div>
                  <ul class="contact-list">
                    <li class="single-contact">
                      <div class="icon">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path d="M11.1285 9.75183C11.2942 9.58619 11.4598 9.41502 11.631 9.24386C12.2218 8.65306 12.5365 7.96841 12.5365 7.27271C12.5365 6.57701 12.2218 5.89787 11.631 5.30156L10.0077 3.67826C9.81995 3.49053 9.63775 3.30281 9.45554 3.11508C9.09113 2.74514 8.72119 2.36416 8.35126 2.01631C7.79359 1.45865 7.13102 1.16602 6.43532 1.16602C5.73962 1.16602 5.07153 1.45865 4.49178 2.01631L2.44333 4.05924C1.70346 4.79911 1.28383 5.70463 1.18997 6.74817C1.08506 8.05123 1.32248 9.44263 1.94641 11.1156C2.90161 13.7052 4.3427 16.107 6.47949 18.68C9.07456 21.783 12.1997 24.229 15.7665 25.9517C17.1248 26.5977 18.9413 27.3541 20.9622 27.4866C21.0892 27.4922 21.2106 27.4977 21.3321 27.4977C22.6904 27.4977 23.7836 27.0284 24.6726 26.0621C24.6781 26.0566 24.6891 26.0455 24.6947 26.0345C25.0094 25.6535 25.3683 25.3112 25.7437 24.9468C25.9977 24.6983 26.2628 24.4443 26.5112 24.1793C27.6762 22.9646 27.6762 21.4241 26.5002 20.2481L23.226 16.9738C22.6683 16.3941 22.0002 16.0849 21.299 16.0849C20.5978 16.0849 19.9297 16.3886 19.3554 16.9628L17.4119 18.9174C17.2352 18.8125 17.053 18.7241 16.8763 18.6358C16.661 18.5254 16.4567 18.426 16.2745 18.31C14.4966 17.1837 12.8843 15.7094 11.3439 13.8156C10.5653 12.8328 10.0463 12.0046 9.68192 11.1598C10.1899 10.7015 10.6703 10.2156 11.1285 9.75183ZM8.66046 10.2598C8.64941 10.2708 8.64389 10.2764 8.63285 10.2874C8.18009 10.7402 8.24635 11.1764 8.35678 11.5076C8.3623 11.5242 8.36782 11.5352 8.37334 11.5518C8.79297 12.5622 9.37824 13.5174 10.2838 14.6659C11.9236 16.6812 13.6408 18.2493 15.5401 19.453C15.7776 19.602 16.026 19.729 16.2635 19.845C16.4788 19.9554 16.6831 20.0548 16.8653 20.1708C16.8874 20.1818 16.9039 20.1928 16.926 20.2039C17.1082 20.2977 17.2794 20.3419 17.4561 20.3419C17.8978 20.3419 18.1794 20.0603 18.2733 19.9665L20.3107 17.9291C20.6254 17.6143 20.9677 17.4487 21.299 17.4487C21.7131 17.4487 22.0444 17.7027 22.2597 17.9291L25.545 21.2143C26.1965 21.8658 26.191 22.5671 25.5284 23.2572C25.2965 23.5002 25.0591 23.7321 24.7996 23.9805C24.4186 24.3505 24.0211 24.7314 23.6622 25.1621C23.0382 25.8357 22.2928 26.1505 21.3266 26.1505C21.2327 26.1505 21.1333 26.1449 21.0395 26.1394C19.2505 26.0235 17.5886 25.3278 16.3463 24.7314C12.9561 23.0916 9.9856 20.7615 7.512 17.8131C5.48012 15.3671 4.1108 13.0868 3.21081 10.6463C2.65867 9.16104 2.44333 7.95737 2.53168 6.86412C2.59241 6.14082 2.874 5.53346 3.39302 5.01997L5.41938 2.99361C5.7341 2.68993 6.08195 2.52981 6.41876 2.52981C6.75004 2.52981 7.08133 2.68441 7.39605 2.99913C7.76046 3.34146 8.10831 3.69483 8.47273 4.07028C8.66046 4.25801 8.84818 4.45126 9.03591 4.64451L10.6592 6.26781C10.996 6.60462 11.1672 6.94694 11.1672 7.27823C11.1672 7.60952 10.996 7.95184 10.6592 8.28865C10.488 8.45982 10.3224 8.63098 10.1512 8.80214C9.65983 9.31011 9.18499 9.796 8.66046 10.2598Z" />
                            <path d="M16.6789 11.9838C16.7808 12.0857 16.9124 12.1366 17.0482 12.1366C17.184 12.1366 17.3156 12.0857 17.4174 11.9838L24.2592 5.13774V9.18681C24.2592 9.47542 24.4927 9.70886 24.7813 9.70886C25.0699 9.70886 25.3033 9.47542 25.3033 9.18681V3.88142C25.3033 3.59281 25.0699 3.35938 24.7813 3.35938H19.4759C19.1873 3.35938 18.9539 3.59281 18.9539 3.88142C18.9539 4.17004 19.1873 4.40347 19.4759 4.40347H23.525L16.6789 11.2495C16.4752 11.4533 16.4752 11.7843 16.6789 11.9838Z" />
                          </g>
                        </svg>
                      </div>
                      <div class="content">
                        <span>Call 24/7 Hours</span>
                        <a href="tel:1300378911">1300 378 911</a>
                      </div>
                    </li>
                    <li class="single-contact">
                      <div class="icon">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M25.4297 3.87695H2.57031C1.88886 3.87772 1.23554 4.14877 0.753674 4.63063C0.271814 5.11249 0.000767151 5.76581 0 6.44727L0 21.5543C0.000767151 22.2357 0.271814 22.889 0.753674 23.3709C1.23554 23.8528 1.88886 24.1238 2.57031 24.1246H25.4297C26.1111 24.1238 26.7645 23.8528 27.2463 23.3709C27.7282 22.889 27.9992 22.2357 28 21.5543V6.44727C27.9992 5.76581 27.7282 5.11249 27.2463 4.63063C26.7645 4.14877 26.1111 3.87772 25.4297 3.87695ZM18.4828 14.0008L26.5688 5.91472C26.6471 6.08133 26.6876 6.26318 26.6875 6.44727V21.5543C26.6876 21.7383 26.6471 21.9202 26.5688 22.0868L18.4828 14.0008ZM25.4297 5.18945H25.4377L14 16.6274L2.56227 5.18967H2.57031L25.4297 5.18945ZM1.43117 22.0868C1.35289 21.9202 1.31237 21.7383 1.3125 21.5543V6.44727C1.31236 6.26318 1.35288 6.08133 1.43117 5.91472L9.51721 14.0008L1.43117 22.0868ZM2.57031 22.8121C2.56763 22.8121 2.56484 22.8121 2.56222 22.8121L10.4453 14.9288L13.536 18.0195C13.6591 18.1426 13.826 18.2117 14.0001 18.2117C14.1741 18.2117 14.341 18.1426 14.4641 18.0195L17.5547 14.9289L25.4377 22.8118C25.435 22.8118 25.4323 22.8118 25.4297 22.8118L2.57031 22.8121Z" />
                        </svg>
                      </div>
                      <div class="content">
                        <span>Send Us Mail</span>
                        <a href="mailto:info@insightwide.com">info@insightwide.com</a>
                      </div>
                    </li>
                  </ul>
                  <a href="https://insightwide.com/" class="primary-btn1" target="_blank">
                    <span>
                      View Live
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5.69375 4.27956C5.70923 4.78621 7.37601 5.47434 7.75696 5.48321L12.0047 5.48321L4.28896 13.199C4.01573 13.4722 4.01572 13.9152 4.28896 14.1885C4.5622 14.4617 5.0052 14.4617 5.27843 14.1885L12.9942 6.47268L12.9942 10.7205C12.9943 11.1068 13.7927 12.7648 14.179 12.7648C14.5654 12.7648 14.3934 11.1068 14.3934 10.7205L14.3934 4.7836C14.3933 4.39726 14.0802 4.08409 13.6938 4.08401L7.75697 4.08401C7.35309 4.08893 5.68406 3.81613 5.69375 4.27956Z" />
                      </svg>
                    </span>
                    <span>
                     View Live
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5.69375 4.27956C5.70923 4.78621 7.37601 5.47434 7.75696 5.48321L12.0047 5.48321L4.28896 13.199C4.01573 13.4722 4.01572 13.9152 4.28896 14.1885C4.5622 14.4617 5.0052 14.4617 5.27843 14.1885L12.9942 6.47268L12.9942 10.7205C12.9943 11.1068 13.7927 12.7648 14.179 12.7648C14.5654 12.7648 14.3934 11.1068 14.3934 10.7205L14.3934 4.7836C14.3933 4.39726 14.0802 4.08409 13.6938 4.08401L7.75697 4.08401C7.35309 4.08893 5.68406 3.81613 5.69375 4.27956Z" />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
              <div class="col-xl-3 col-lg-2 col-sm-6">
                <div class="footer-widget">
                  <div class="widget-title">
                    <h3>Company</h3>
                  </div>
                  <ul class="widget-list">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                     <a href="https://insightwide.com/" target="_blank" rel="noopener noreferrer">Our Software</a>
                    </li>
                    
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-sm-6 d-flex justify-content-lg-end">
                <div class="footer-widget">
                  <div class="widget-title">
                    <h3>Solutions</h3>
                  </div>
                  <ul class="widget-list">
                    <li>
                      <Link to="/supply-chain">Supply Chain</Link>
                    </li>
                    <li>
                      <Link to="/manufacturing">Manufacturing</Link>
                    </li>
                    <li>
                      <Link to="/construction">Construction</Link>
                    </li>
                    <li>
                      <Link to="/retail">Retail</Link>
                    </li>
                    <li>
                      <Link to="/crm">CRM</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <a href="assets/company-desk.pdf" class="file-download-btn" download>
            <div class="icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10.6758 2.80469H13.3242V11.0102H17.0039L12 17.5609L6.99609 11.0102H10.6758V2.80469Z" />
                <path d="M10.6758 3.1566H13.3266L12.975 2.80504V9.99801C12.975 10.3308 12.9633 10.6636 12.975 10.9964V11.0105C12.975 11.2004 13.1367 11.3621 13.3266 11.3621H17.0062C16.9055 11.1863 16.8047 11.0105 16.7016 10.8324C16.5352 11.0504 16.3711 11.266 16.2047 11.4839C15.8062 12.0043 15.4078 12.5246 15.0117 13.0472C14.5312 13.6777 14.0484 14.3082 13.568 14.9386C13.1508 15.4847 12.7336 16.0285 12.3187 16.5746C12.1172 16.8394 11.8969 17.0972 11.7094 17.3714C11.707 17.3761 11.7023 17.3785 11.7 17.3832H12.307C12.1406 17.1652 11.9766 16.9496 11.8102 16.7316C11.4117 16.2113 11.0133 15.691 10.6172 15.1683C10.1367 14.5379 9.6539 13.9074 9.17343 13.2769C8.75625 12.7308 8.33906 12.1871 7.92422 11.641C7.72265 11.3761 7.53281 11.0949 7.31484 10.8441C7.3125 10.8394 7.30781 10.8371 7.30547 10.8324C7.20469 11.0082 7.1039 11.1839 7.00078 11.3621H10.6805C10.8703 11.3621 11.032 11.2004 11.032 11.0105V3.81754C11.032 3.48473 11.0437 3.15192 11.032 2.8191V2.80504C11.032 2.62223 10.8703 2.4441 10.6805 2.45348C10.4906 2.46285 10.3289 2.60817 10.3289 2.80504V9.99801C10.3289 10.3285 10.3102 10.666 10.3289 10.9964V11.0105L10.6805 10.6589H7.00078C6.75937 10.6589 6.52969 10.9683 6.69609 11.1886C6.8625 11.4066 7.02656 11.6222 7.19297 11.8402C7.5914 12.3605 7.98984 12.8808 8.38593 13.4035C8.8664 14.0339 9.34922 14.6644 9.82968 15.2949C10.2469 15.841 10.6641 16.3847 11.0789 16.9308C11.2828 17.1957 11.4844 17.4629 11.6883 17.7277C11.6906 17.7324 11.6953 17.7347 11.6977 17.7394C11.8687 17.9621 12.1336 17.9621 12.3047 17.7394C12.4711 17.5214 12.6352 17.3058 12.8016 17.0879C13.2 16.5675 13.5984 16.0472 13.9945 15.5246C14.475 14.8941 14.9578 14.2636 15.4383 13.6332C15.8555 13.0871 16.2727 12.5433 16.6875 11.9972C16.8891 11.7324 17.1117 11.4769 17.2969 11.2004C17.2992 11.1957 17.3039 11.1933 17.3062 11.1886C17.475 10.9683 17.2453 10.6589 17.0016 10.6589H13.3219L13.6734 11.0105V3.81754C13.6734 3.48473 13.6852 3.15192 13.6734 2.8191V2.80504C13.6734 2.6152 13.5117 2.45348 13.3219 2.45348H10.6711C10.4883 2.45348 10.3102 2.6152 10.3195 2.80504C10.3312 2.99489 10.4789 3.1566 10.6758 3.1566Z" />
                <path d="M20.9297 17.2117V19.9609C20.9297 20.1132 20.939 20.2726 20.9203 20.425C20.9297 20.3617 20.9367 20.3007 20.9461 20.2375C20.9344 20.3101 20.9156 20.3804 20.8875 20.4507L20.9578 20.282C20.9367 20.3289 20.9133 20.3757 20.8875 20.4203C20.843 20.4882 20.8031 20.4836 20.925 20.3781C20.9062 20.3945 20.8898 20.4156 20.8734 20.4343C20.8664 20.4414 20.8195 20.4882 20.8172 20.4859C20.8125 20.4836 20.9859 20.3734 20.8734 20.439C20.8242 20.4695 20.7773 20.4953 20.7234 20.5187L20.8922 20.4484C20.8219 20.4765 20.7539 20.4953 20.6789 20.507C20.7422 20.4976 20.8031 20.4906 20.8664 20.4812C20.6789 20.5047 20.482 20.4906 20.2945 20.4906H3.2906C3.23904 20.4906 3.18982 20.4882 3.13826 20.4812C3.20154 20.4906 3.26248 20.4976 3.32576 20.507C3.2531 20.4953 3.18279 20.4765 3.11248 20.4484L3.28123 20.5187C3.23435 20.4976 3.18748 20.4742 3.14295 20.4484C3.07498 20.4039 3.07967 20.364 3.18514 20.4859C3.16873 20.4672 3.14764 20.4507 3.12889 20.4343C3.12185 20.4273 3.07498 20.3804 3.07732 20.3781C3.07967 20.3734 3.18982 20.5468 3.1242 20.4343C3.09373 20.3851 3.06795 20.3382 3.04451 20.2843L3.11482 20.4531C3.0867 20.3828 3.06795 20.3148 3.05623 20.2398C3.0656 20.3031 3.07264 20.364 3.08201 20.4273C3.0656 20.2984 3.07264 20.1648 3.07264 20.0359V17.2164C3.07264 16.8484 2.7492 16.4968 2.36951 16.5132C1.98748 16.5297 1.66639 16.8226 1.66639 17.2164V19.9726C1.66639 20.0804 1.66404 20.1906 1.66639 20.2984C1.6781 20.9875 2.10232 21.564 2.73982 21.8078C2.96951 21.8968 3.20857 21.9015 3.44998 21.9015H20.7117C21.6047 21.8992 22.3289 21.1937 22.343 20.2984C22.357 19.3703 22.343 18.4422 22.343 17.514V17.2164C22.343 16.8484 22.0195 16.4968 21.6398 16.5132C21.2508 16.525 20.9297 16.8179 20.9297 17.2117Z" />
              </svg>
            </div>
            Company Desk
          </a>
          <div class="logo-and-sevice-menu-wrap">
            <a class="footer-logo" href="#">
              <img src="assets/logo-final.png" alt="" />
            </a>
            <ul class="service-list">
              
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
            </ul>
          </div>
          <div class="copyright-and-social-area">
            <p>
              &copy;Copyright 2026{" "}
              <a href="https://www.egenslab.com/">Insight Wide</a> | All Right
              Reserved.
            </p>
            <ul class="social-list">
              <li>
                <a href="https://www.facebook.com/">
                  <i class="bx bxl-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://x.com/">
                  <i class="bi bi-twitter-x"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/">
                  <i class="bx bxl-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/">
                  <i class="bx bxl-instagram-alt"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
